<div class="b-video-layer videoLayerWidthOverload" *ngIf="template == 'tmaster' && duelSeries">
    <div class="row">
        <div class="col b-player b-player-one">
            <div class="b-player-country" *ngIf="duelSeries.player_one.country_code">
                <span class="fi fi-{{ duelSeries.player_one.country_code }}"></span>
            </div>
            <div class="b-player-name">{{ duelSeries.player_one.full_name }}</div>
            <div class="b-player-score">{{ duelSeries.player_one_score }}</div>
            <div class="b-player-balls" *ngIf="duel">
                <div class="b-player-ball" *ngFor="let ball of player1Balls"></div>
            </div>
        </div>
        <div class="col-auto b-games-count" *ngIf="duelSeries.wins_count">
            {{ duelSeries.wins_count }}
        </div>
        <div class="col b-player b-player-two" [class.ps-0]="duelSeries.wins_count">
            <div class="b-player-score">{{ duelSeries.player_two_score }}</div>
            <div class="b-player-name">{{ duelSeries.player_two.full_name }}</div>
            <div class="b-player-country" *ngIf="duelSeries.player_two.country_code">
                <span class="fi fi-{{ duelSeries.player_two.country_code }}"></span>
            </div>
            <div class="b-player-balls" *ngIf="duel">
                <div class="b-player-ball" *ngFor="let ball of player2Balls"></div>
            </div>
        </div>
    </div>
</div>

<div class="b-video-layer-km2021" *ngIf="template == 'km2021' && duelSeries">
    <div class="b-player b-player-one">
        <div class="b-player-name">{{ duelSeries.player_one.full_name }}</div>
        <div class="b-player-score">{{ duelSeries.player_one_score }}</div>
        <div class="b-player-balls" *ngIf="duel">
            <div class="b-player-ball" *ngFor="let ball of player1Balls"></div>
        </div>
    </div>
    <div class="b-player b-player-two">
        <div class="b-player-score">{{ duelSeries.player_two_score }}</div>
        <div class="b-player-name">{{ duelSeries.player_two.full_name }}</div>
        <div class="b-player-balls" *ngIf="duel">
            <div class="b-player-ball" *ngFor="let ball of player2Balls"></div>
        </div>
    </div>
</div>
